import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.riskLevelDescriptions;
export const riskLevelDescriptionsSelector = (state: RootState) => getState(state).data;
export const riskLevelDescriptionsIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const riskLevelDescriptionsIsReadySelector = (state: RootState) => getState(state).isReady;
export const riskLevelDescriptionsErrorSelector = (state: RootState) => getState(state).error;
